import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { actions, getJWT } from "../modules/auth";
const sidebarImage = require("../assets/img/sidebar.png");
class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth
    };
  }
  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  }
  updateDimensions() {
    this.setState({ width: window.innerWidth });
  }
  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }
  onClickLogout = () => {
    document.getElementById("bodyClick") && document.getElementById("bodyClick").remove()          
    const {
      logout,
      history: { replace }
    } = this.props;
    logout().then(() => {
      replace("/");
    });
  };
  render() {
    const { currentDealer, role, routes, jwt } = this.props;
    return (
      <div
        id="sidebar"
        className="sidebar"
        style={{ backgroundImage: "url(" + sidebarImage + ")" }}
      >
        <div className="logo">
          <a href="/" className="simple-text logo-normal">
            {currentDealer ? currentDealer.name : "Dealer Service Pro"}
          </a>
        </div>
        <div className="sidebar-wrapper">
          <ul className="nav">
            {routes.map(prop => {
              if (!prop.redirect && prop.roles.includes(role))
                return (
                  <li className={this.activeRoute(prop.path)} key={prop.name}>
                    <NavLink
                      to={prop.path}
                      className="nav-link"
                      activeClassName="active"
                    >
                      <i className={prop.icon} />
                      <p>{prop.name}</p>
                      {document.getElementById("bodyClick") && document.getElementById("bodyClick").remove()}
                    </NavLink>
                  </li>
                );
              return null;
            })}
            {jwt && (
              <li onClick={this.onClickLogout}>
                <NavLink to="" className="nav-link" activeClassName="active">
                  <i className="pe-7s-door-lock" />
                  <p>Logout</p>
                </NavLink>
              </li>
            )}
          </ul>
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    currentDealer: state.dealers.currentDealer,
    role: state.settings.role,
    jwt: getJWT(state)
  }),
  { logout: actions.logout }
)(Sidebar);
